import { makeStyles } from 'tss-react/mui';
import { PRIMARY_PAYMENT_DARK, PRIMARY_PAYMENT_DEFAULT, WHITE } from 'src/global/theme/colors';

export const styles = makeStyles()(() => {
  return {
    container: {},
    form: {
      backgroundColor: WHITE,
      borderRadius: '10px',
      border: '1px solid #E0E0E0',
      padding: '16px',
      // La tabla de resultados trae su propio margen lateral de 40px: el form usa el mismo.
      margin: '0 40px'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '12px'
    },
    actions: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '16px'
    },
    hint: {
      color: '#6B6B6B'
    },
    // Mismo boton que "Descargar CSV": el verde del portal con texto blanco.
    // Sin esto, variant="contained" toma el verde claro del theme y MUI calcula
    // texto negro, que es ilegible sobre ese fondo.
    submitButton: {
      height: '48px',
      padding: '4px 30px',
      borderRadius: '8px',
      backgroundColor: PRIMARY_PAYMENT_DEFAULT,
      color: WHITE,
      fontSize: '15px',
      fontWeight: 400,
      lineHeight: '22px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: PRIMARY_PAYMENT_DARK
      }
    },
    results: {
      marginTop: '16px'
    },
    // El popup del DateTimePicker: las listas de hora y minuto necesitan ancho
    // propio, si no el contenido se corta y el scroll tapa los numeros.
    pickerPaper: {
      // Mismo verde y mismo texto blanco que los botones: el primary del theme
      // es el verde medio, y sobre ese fondo MUI calcula texto negro.
      '& .MuiPickersDay-root.Mui-selected, & .MuiMultiSectionDigitalClockSection-item.Mui-selected':
        {
          backgroundColor: PRIMARY_PAYMENT_DEFAULT,
          color: WHITE,
          fontWeight: 500,
          '&:hover, &:focus': {
            backgroundColor: PRIMARY_PAYMENT_DARK
          }
        },
      '& .MuiPickersDay-root.MuiPickersDay-today:not(.Mui-selected)': {
        borderColor: PRIMARY_PAYMENT_DEFAULT
      },
      '& .MuiMultiSectionDigitalClock-root': {
        width: 'auto'
      },
      '& .MuiMultiSectionDigitalClock-root ul': {
        width: '72px',
        scrollbarWidth: 'thin'
      },
      '& .MuiMultiSectionDigitalClockSection-item': {
        width: '56px',
        justifyContent: 'center'
      }
    },
    feedback: {
      margin: '0 40px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
      padding: '24px 0'
    }
  };
});
